import React, { useEffect } from "react";

const PageTransition = ({ children, className = "" }) => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Add smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className={`page-animate w-full h-full ${className}`}>
      {children}
    </div>
  );
};

export default PageTransition;
